module.exports = __webpack_public_path__ + "img/call.ebc900f0.svg";